/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_TitleInputs */

const en_task_reminders_title = /** @type {(inputs: Task_Reminders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders`)
};

const pt_br2_task_reminders_title = /** @type {(inputs: Task_Reminders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembretes`)
};

/**
* | output |
* | --- |
* | "Reminders" |
*
* @param {Task_Reminders_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_title = /** @type {((inputs?: Task_Reminders_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_title(inputs)
	return pt_br2_task_reminders_title(inputs)
});